/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListTunneledMcpServersSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListTunneledMcpServersSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListTunneledMcpServersSecurity = {
  option1?: ListTunneledMcpServersSecurityOption1 | undefined;
  option2?: ListTunneledMcpServersSecurityOption2 | undefined;
};

export type ListTunneledMcpServersRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListTunneledMcpServersSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListTunneledMcpServersSecurityOption1$outboundSchema:
  z.ZodMiniType<
    ListTunneledMcpServersSecurityOption1$Outbound,
    ListTunneledMcpServersSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function listTunneledMcpServersSecurityOption1ToJSON(
  listTunneledMcpServersSecurityOption1: ListTunneledMcpServersSecurityOption1,
): string {
  return JSON.stringify(
    ListTunneledMcpServersSecurityOption1$outboundSchema.parse(
      listTunneledMcpServersSecurityOption1,
    ),
  );
}

/** @internal */
export type ListTunneledMcpServersSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListTunneledMcpServersSecurityOption2$outboundSchema:
  z.ZodMiniType<
    ListTunneledMcpServersSecurityOption2$Outbound,
    ListTunneledMcpServersSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function listTunneledMcpServersSecurityOption2ToJSON(
  listTunneledMcpServersSecurityOption2: ListTunneledMcpServersSecurityOption2,
): string {
  return JSON.stringify(
    ListTunneledMcpServersSecurityOption2$outboundSchema.parse(
      listTunneledMcpServersSecurityOption2,
    ),
  );
}

/** @internal */
export type ListTunneledMcpServersSecurity$Outbound = {
  Option1?: ListTunneledMcpServersSecurityOption1$Outbound | undefined;
  Option2?: ListTunneledMcpServersSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListTunneledMcpServersSecurity$outboundSchema: z.ZodMiniType<
  ListTunneledMcpServersSecurity$Outbound,
  ListTunneledMcpServersSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListTunneledMcpServersSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListTunneledMcpServersSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listTunneledMcpServersSecurityToJSON(
  listTunneledMcpServersSecurity: ListTunneledMcpServersSecurity,
): string {
  return JSON.stringify(
    ListTunneledMcpServersSecurity$outboundSchema.parse(
      listTunneledMcpServersSecurity,
    ),
  );
}

/** @internal */
export type ListTunneledMcpServersRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListTunneledMcpServersRequest$outboundSchema: z.ZodMiniType<
  ListTunneledMcpServersRequest$Outbound,
  ListTunneledMcpServersRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function listTunneledMcpServersRequestToJSON(
  listTunneledMcpServersRequest: ListTunneledMcpServersRequest,
): string {
  return JSON.stringify(
    ListTunneledMcpServersRequest$outboundSchema.parse(
      listTunneledMcpServersRequest,
    ),
  );
}
